export const usersPerPage = 5;
